"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldWrapper_1 = require("./FieldWrapper");
var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["NUMBER"] = "number";
    InputType["PASSWORD"] = "password";
    InputType["CHECKBOX"] = "checkbox";
    InputType["TEXTAREA"] = "textarea";
    InputType["COLOR"] = "colorpicker";
    InputType["STRING_ARRAY"] = "stringarray";
})(InputType = exports.InputType || (exports.InputType = {}));
FieldWrapper_1.register(InputType.TEXT, new FieldWrapper_1.default({ dataType: "string" }));
FieldWrapper_1.register(InputType.NUMBER, new FieldWrapper_1.default({ dataType: "number" }));
FieldWrapper_1.register(InputType.PASSWORD, new FieldWrapper_1.default({ dataType: "string", uiWidget: "password" }));
FieldWrapper_1.register(InputType.CHECKBOX, new FieldWrapper_1.default({ dataType: "boolean" }));
FieldWrapper_1.register(InputType.TEXTAREA, new FieldWrapper_1.default({ dataType: "string", uiWidget: "textarea" }));
FieldWrapper_1.register(InputType.COLOR, new FieldWrapper_1.default({ dataType: "string", uiWidget: "color" }));
FieldWrapper_1.register(InputType.STRING_ARRAY, new FieldWrapper_1.default({ dataType: "array", arrayType: "string" }));
//# sourceMappingURL=InputType.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/fields/InputType.js
// module id = 1458
// module chunks = 0